import { useLocation } from '@atlassian/mpac-ui';
import React, { lazy, Suspense } from 'react';

import HelpDropdown from './HelpDropdown';

type ShowHelpProps = {
  userLoggedIn: boolean;
};
const InProductHelpCodeSplit = lazy(
  () => import(/* webpackChunkName: "inProductHelp" */ './InProductHelp/InProductHelp')
);

const ShowHelp = ({ userLoggedIn }: ShowHelpProps) => {
  const { pathname } = useLocation();
  return userLoggedIn && pathname?.includes('manage/vendors') ? (
    <Suspense fallback={<div />}>
      <InProductHelpCodeSplit />
    </Suspense>
  ) : (
    <HelpDropdown />
  );
};

export default ShowHelp;
